@use '../../styling/colors.scss' as *;

.Card {
  border: 1px solid $theme-color-borders;
  border-radius: 6px;
  background: $theme-color-background;

  &.OverflowHidden {
    overflow: hidden;
    height: 100%;
  }

  &.shadow {
    box-shadow: 1px 1px 1px 1px $theme-color-shadow;
  }

  &.TransparentBackground {
    background: $color-transparent;
  }

  &.Opacity {
    opacity: 0.5;
  }

  >div {

    // a border is not needed if there is only one element
    &:not(:first-child) {
      border-top: 1px solid $theme-color-borders;
    }

    &:last-child {
      border-bottom-left-radius: inherit;
      border-bottom-right-radius: inherit;
    }
  }
}
